var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{style:(("overflow: " + _vm.overflow + ";\n    flex-wrap: " + _vm.wrap + ";\n    width: " + _vm.width + ";\n    height: " + _vm.height + ";\n    align-content: " + _vm.alignContent))},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }